import { IString, TableFilter, TableFilterMode } from '../../model';
import { FilterCustomComponent } from './custom';
import { renderFilterBoxSlot } from './func';
import { FilterInputComponent } from './input';
import { FilterSelectComponent } from './select';

interface IProps<T> {
  readonly columnIndex: number;
  readonly columnKey: string;
  readonly filters: TableFilter<T>;
  readonly filterValues: IString<string | string[]>;
  readonly onChangedFilterValues: (
    key: string,
    value: string | string[]
  ) => void;
}

export function FilterComponent<T>(props: IProps<T>) {
  const { filters, onChangedFilterValues, filterValues, columnKey } = props;
  const value = filterValues[columnKey];

  if (filters.kind === TableFilterMode.menu) {
    return renderFilterBoxSlot(
      <FilterSelectComponent<T>
        value={value}
        columnKey={columnKey}
        filters={filters}
        onChanged={onChangedFilterValues}
      />,
      !!value
    );
  }

  if (filters.kind === TableFilterMode.input) {
    return renderFilterBoxSlot(
      <FilterInputComponent<T>
        value={value}
        columnKey={columnKey}
        filters={filters}
        onChanged={onChangedFilterValues}
      />,
      !!value
    );
  }

  if (filters.kind === TableFilterMode.custom) {
    return renderFilterBoxSlot(
      <FilterCustomComponent<T>
        value={value}
        columnKey={columnKey}
        filters={filters}
        onChanged={onChangedFilterValues}
      />,
      !!value
    );
  }

  return null;
}
